import { render, staticRenderFns } from "./FormProductItemSettings.vue?vue&type=template&id=ad86e3d6"
import script from "./FormProductItemSettings.vue?vue&type=script&lang=js"
export * from "./FormProductItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports